// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorMessage_wrapper__oXhQC","title":"ErrorMessage_title__jXUJx","text":"ErrorMessage_text__Iuc2s","close":"ErrorMessage_close__fAVWU"};